import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/users";

export async function getUsers() {
  const response = await http.get(apiEndpoint);
  return response.data;
}

export async function getUser(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function saveUser(user) {
  let userInDb = user || {};
  userInDb.name = user.name;

  if (userInDb.id === -1) await http.post(apiEndpoint, userInDb);
  else await http.put(apiEndpoint + "/" + userInDb.id, userInDb);

  return userInDb;
}

export async function deleteUser(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/userService.js